<template>
    <div class="wrapper">
        <!-- 头图 -->
        <header>
            <img :src="ui.head" alt="头图" class="header_img"/>
        </header>
<!--     style="background: #239aff"    -->
        <div :style="`backgroundColor:${ui.bg_color}`" ref="main" class="main_wrapper">
            <!-- 倒计时 -->
            <countDown v-if="ui.is_counter" :labelColor="ui.font_color"
                       :stime="stime"></countDown>
            <div class="form_wrapper" ref="form_wrapper">
                <!-- 表单部分 -->

                <van-form ref="actionForm" class="form_wrap">
                    <div style="position: relative;width: 100%;">
                        <img src="../../assets/image/fanglz_top.png" style="width: 100%;height: auto;margin: 0">
                        <div class="sjz_tip">
                            【入场参观门票】仅限本届展会使用
                        </div>
                    </div>
                    <div class="inner_lz_wrapper">
                           <div>
                               <img src="../../assets/image/fanglz_ticket.png" class="lz_ticket">
                           </div>
                        <div style="width: 90%;margin-left: 5%;margin-top: 10px">
                            <p class="vant_label" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}"
                               v-if="is_city">快速选择城市<img src="../../assets/image/bitian.png" style="width: 18px;"></p>
                            <div class="field_outbox" v-if="is_city">
                                <van-field
                                        :border="false"
                                        v-if="is_city"
                                        readonly
                                        is-link
                                        v-model="action_form.city"
                                        name="城市"
                                        placeholder="请选择城市"
                                        @click="city_show = true"
                                />
                            </div>
<!--                            <p class="vant_label" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}">怎么称呼您-->
<!--                                <img src="../../assets/image/bitian.png" style="width: 18px;">-->
<!--                            </p>-->
<!--                            <div class="field_outbox">-->
<!--                                <van-field-->
<!--                                        v-model="action_form.name"-->
<!--                                        name="姓名"-->
<!--                                        placeholder="请输入姓名"-->
<!--                                        :border="false"-->
<!--                                />-->
<!--                            </div>-->
                            <p class="vant_label" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}">
                                您的手机号(已加密)<img src="../../assets/image/bitian.png" style="width: 18px;"></p>
                            <div class="field_outbox">
                                <van-field
                                        type="tel"
                                        v-model="action_form.phone"
                                        name="电话"
                                        placeholder="请输入电话"
                                        :border="false"
                                />
                            </div>

                            <div class="policy_wrapper">
                                <policy></policy>
                            </div>

                        </div>

                        <!--  异形圆角-->
                        <div style="position: relative;width: 100%;height: 1px">
                            <div class="special coupon_l_t" :style="`backgroundColor:${ui.bg_color}`"></div>
                            <div class="special coupon_r_t" :style="`backgroundColor:${ui.bg_color}`"></div>
                            <div class="special coupon_l_b" :style="`backgroundColor:${ui.bg_color}`"></div>
                            <div class="special coupon_r_b" :style="`backgroundColor:${ui.bg_color}`"></div>
<!--                            <div class="dashed"></div>-->
                        </div>

                        <!--  表单提交按钮-->
                        <div style="width: 90%;padding-bottom: 15px;margin-left: 5%;padding-top: 10px">
                            <div>
                                <div
                                        class="form_item_btn sjz_form_btn"
                                        round v-if="!is_stop" @click="submitForm"
                                        :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
                                    {{ui.btn_text}}
                                    <img src="../../assets/image/sjz/poniter.png" class="pointer_img">
                                </div>
                                <van-button class="form_item_btn"
                                            type="info" round v-if="is_stop" :disabled="true">活动已结束
                                </van-button>
                            </div>
                        </div>

                        <!-- 走马灯-->
                        <div  v-if="ui.is_banner" style="padding-bottom: 20px">
                            <banner></banner>

                        </div>

                    </div>
                    <div style="position: relative;top: -7px">
                        <img src="../../assets/image/fanglz_b.png" style="width: 100%;height: auto;margin: 0">
                    </div>
<!--                    <div style="" class="real_form"></div>-->
                </van-form>
            </div>

        </div>
        <div class="detail_img" :class="ui.is_copyright ? '' : 'pb_20'">
            <!-- 详情图-->
            <img :src="ui.tail" alt="" class="detail_img" ref="tailImage"/>
        </div>
        <!-- 版权-->
        <div>
            <copyright v-if="ui.is_copyright"></copyright>
        </div>
        <div v-if="btn_show" class="footer_wrapper">
            <div class="bottom_btn"
                 @click="btn_click_form"
                 :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
                {{ui.btn_text}}
            </div>
        </div>

        <!-- 报名成功弹框-->
        <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" width="50%">
            <el-result icon="success" title="报名成功"></el-result>
        </el-dialog>

        <!-- 城市弹框-->
        <!--:style="{height: '50%'}" :lock-scroll="false"-->
        <van-popup v-model="city_show" round position="bottom" :safe-area-inset-bottom="true">
            <!--  style="height: 100%;overflow-x: hidden;overflow-y: auto"-->
            <van-cascader
                    v-model="cascaderValue"
                    title="请选择所在地区"
                    :options="citys"
                    :fieldNames="cityNames"
                    @close="city_show = false"
                    @finish="finishCity"
                    class="city_cascader"
            />
        </van-popup>
    </div>
</template>

<script>
    import countDown from "@/components/countDown";
    import policy from "@/components/policy";
    import copyright from "@/components/copyright";
    import banner from "@/components/banner";
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import lib_city from "@/libs/lib_city";
    import _wx from "@/common/_wx";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import _regular from "@/utils/_regular";
    import lib_clue from "@/libs/lib_clue";
    import lib_success from "@/libs/lib_success";
    import cache_url from "@/cache/cache_url";
    import Toast from "vant/lib/toast";
    import _monitor from "@/monitor/_monitor";

    let action_form = {
        name: '', //姓名
        phone: '', //电话
        city: '', //城市
    }

    export default {
        name: "fanglz",
        components: {
            countDown,
            policy,
            copyright,
            banner,
        },
        data() {
            return {
                title: '', // document的title
                activity_id: 0, //活动ID
                tids: "", //模板ID
                channel: '', //渠道
                channel_name: '', //渠道名
                tid: 0, // 有无车型库
                share_theme: '', //分享描述
                stime: 0, // 项目开始时间
                etime: 0, // 项目结束时间
                ui: {
                    head: '', //头图
                    tail: '', //详情图
                    share: '', //分享图
                    bg_color: '', //表单背景色
                    font_color: '', //文本颜色
                    btn_bg_color: '', //按钮背景色
                    btn_font_color: '', //按钮文本颜色
                    btn_text: '', //按钮文本值
                    btm_btn_text: '', //底部按钮文本
                    is_banner: 0, //是否有轮播图
                    is_counter: 0, //是否有倒计时
                    is_copyright: 1, //协议
                    jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
                },

                action_form: action_form,
                //城市联级选择
                citys: [], //城市数据
                cascaderProps: { //配置项
                    expandTrigger: 'hover', //展开方式
                    value: "id", //指定选项的值
                    label: "name", //指定选项标签
                    children: "children", //指定选项的子选项
                    emitPath: false, //该节点数组
                },

                is_success: false, //报名成功弹框
                is_city: false, //表单城市项，默认无城市
                is_stop: false, //活动是否已结束
                is_display: true, //底部按钮
                btn_show: false, //底部按钮显隐
                series_name: "请选择意向车型",


                // vant相关
                city_show: false,
                cascaderValue: '', //
                cityNames: {
                    text: 'name',
                    value: 'id',
                    children: 'children',
                },
            }
        },
        created() {
            // 地址栏
            this.activity_id = _geturl("activity_id");
            this.tids = _geturl("tids");
            this.channel = _geturl("channel");
            this.channel_name = _geturl("channel_name");

            //获取项目信息
            lib_activity.info(this.activity_id, this.tids, this.init_info);

            //监测
            _monitor.init(this.channel, this.activity_id);

        },
        mounted() {
            // 监听页面滚动
            window.addEventListener('scroll', this.handleScroll, true)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll, true)
        },
        destroyed() {
            // window.removeEventListener('scroll', this.handleScroll())
        },
        methods: {
            //初始化项目信息
            init_info(data) {
                console.log(data)
                this.title = data.activity.theme;
                document.title = this.title;
                this.share_theme = data.activity.share_theme;
                this.etime = data.activity.etime;
                this.stime = data.activity.stime;
                this.tid = data.activity.tid;
                if(data.ui == null) {
                    this.ui = {};
                    return;
                }
                this.ui = data.ui;

                // 项目结束
                if (!data.activity.state || (_time._current() > data.activity.etime)) {
                    this.is_stop = true;
                    return;
                }
                // 判断是否有城市
                let city = []
                if (data.activity.city) {
                    city = data.activity.city.split(',');
                }
                if (city.length == 1 && city[0] > 0) {
                    //单城市项目
                    this.is_city = false;
                } else {
                    //多城市项目
                    this.is_city = true;
                    this.getCity(data.activity.city)
                }
                // 分享： ui存在再分享
                if (_object._length(this.ui) > 0) {
                    this.share();
                }
            },

            // 分享
            share() {
                let that = this;
                lib_activity.share(function (data) {
                    let options = {};
                    options.title = that.title;
                    options.desc = that.share_theme;
                    options.link = window.location.href;
                    options.image = that.ui.share;

                    _wx.js_api(data, _wx.share, options);
                })
            },
            // 加载城市
            getCity(city) {
                let that = this;
                lib_city.list(city, function (data) {
                    that.citys = data;
                })
            },

            submitForm() {
                if (this.is_city && !this.action_form.city) {
                    Toast('请选择城市');
                    return;
                }
                // if (!this.action_form.name) {
                //     Toast('请输入您的姓名');
                //     return;
                // }
                // if(this.action_form.name && this.action_form.name.length>20) {
                //     Toast('请输入正确的姓名');
                //     return;
                // }
                if (!this.action_form.phone) {
                    Toast('请输入您的手机号');
                    return;
                }
                if (!_regular.is_mobile(this.action_form.phone)) {
                    Toast('请输入正确的手机号');
                    return;
                }
                let cityArr = this.action_form.city.split('/'); // vant形式
                let location = this.is_city ? (cityArr[0] + '+' + cityArr[1]) : '';
                let url = window.location.href;
                let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
                let params = {
                    activity_id: this.activity_id,
                    channel_code: this.channel,
                    channel_name: this.channel_name,
                    location,
                    url,
                    form_name: '未命名',
                    form_phone: this.action_form.phone,
                    form_ui_id,
                };
                let that = this;
                // console.log(params, '入参')
                // return;
                lib_clue.receive(params, function (data) {
                    //监测上报
                    _monitor.submit()

                    //缓存当页面链接
                    cache_url.set(window.location.href)
                    //跳转
                    // setTimeout(() => {
                    // }, 2000);
                    //不同参数跳转不同页面
                    const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 0
                    //跳转地址
                    const url = lib_success.jmp_url(jmp_url)
                    that.$router.push({
                        path: url,
                        query: {
                            id: data.id
                        },
                    })
                })
            },

            // 滚到表单开始部分
            btn_click_form() {
                let form_top = this.$refs.main.offsetTop - 50;
                document.documentElement.scrollTop = form_top
                document.body.scrollTop = form_top;
                document.querySelector('#app').scrollTop = form_top
            },
            // 滚动
            handleScroll() {
                let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('#app').scrollTop;
                this.$nextTick(() => {
                    if (scrollHeight >= this.$refs.tailImage.offsetTop) {
                        this.btn_show = true;
                    } else {
                        this.btn_show = false;
                    }
                })
            },

            // vant相关
            finishCity({selectedOptions}) {
                this.city_show = false;
                this.action_form.city = selectedOptions.map((option) => option.name).join('/');
            },
        },
    };
</script>

<style lang="less" scoped>
    @import "../../assets/style/autoshow/base.less";
    @import "../../assets/style/autoshow/form.less";
    // form部分
    @import "../../assets/style/common/successful.less"; //报名成功
    .city_cascader {
        /deep/ .van-tabs .van-tabs--line .van-cascader__tabs {
            overflow-y: auto;
        }
    }
    .field_outbox {

        /deep/ .van-cell {
            border: none;
            border-radius: 0px !important;
            background-color: transparent;
            padding: 8px 12px;
            border-bottom: solid 1px rgb(215,215,215) !important;
            /*border-bottom: solid 1px #d8d8d8 !important;*/
        }
    }
    .sjz_tip{
        width: 100%;
        position: absolute;
        font-size: 22px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -45%);
        color: #757575;
        text-align: center;
    }
    .form_wrap{
        border-radius: 20px;
        box-sizing: border-box;
        /*padding-bottom: 20px;*/
    }
    .real_form{
        background-color: #fff;
        padding: 10px 20px;
        box-sizing: border-box;
        border-radius: 20px;
        margin-top: -20px;
    }
    .inner_lz_wrapper{
        width: 100%;
        background: #fefcf4;
        position: relative;
        top: -6px;
    }
    .lz_ticket{
        width: 80%;
        height: auto;
        margin-left: 10%;
        margin-top: 20px;
    }
    /* 异形 */
    .special{
        position: absolute;
        width: 20px;
        height: 20px;
        /*background-color: #239aff;*/
    }

    .coupon_r_t{
        border-radius: 0 0 0 100%;
        top: 0;
        right: 0;
    }
    .coupon_r_b{
        border-radius: 100% 0 0 0;
        right: 0;
        bottom: 0;
    }
    .coupon_l_t{
        left: 0;
        top: 0;
        border-radius: 0 0 100% 0;
    }
    .coupon_l_b{
        left: 0;
        bottom: 0;
        border-radius: 0 100% 0 0;
    }
    .dashed{
        position: absolute;
        /*top: 14%;*/
        right: 5%;
        width: 90%;
        height: 3px;
        background-image: linear-gradient(to right, #3e3e3e 35%, #fff 0%); /* 35%设置虚线点x轴上的长度 */
        background-position: bottom; /* top配置上边框位置的虚线 */
        background-size: 10px 2px; /* 第一个参数设置虚线点的间距；第二个参数设置虚线点y轴上的长度 */
        background-repeat: repeat-x;
    }
</style>

